module.exports = __webpack_public_path__ + "app-static/img/16.0be08383.png";